"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_EVALOC = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F5F8F7" },
          100: { value: "#D6E3E1" },
          200: { value: "#B3CBC7" },
          300: { value: "#88ADA7" },
          400: { value: "#709D96" },
          500: { value: "#50877E" },
          600: { value: "#40726A" },
          700: { value: "#335C55" },
          800: { value: "#2B4D48" },
          900: { value: "#1F3834" },
        },
        secondary: {
          50: { value: "#F5F8F7" },
          100: { value: "#D6E3E1" },
          200: { value: "#B3CBC7" },
          300: { value: "#88ADA7" },
          400: { value: "#709D96" },
          500: { value: "#50877E" },
          600: { value: "#40726A" },
          700: { value: "#335C55" },
          800: { value: "#2B4D48" },
          900: { value: "#1F3834" },
        },
      },
    },
  },
});
